import { Route, Routes } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { NotFound } from "@gui/pages/NotFound/NotFound";
import { LegacyRedirect } from "./LegacyRedirect";
import { RequireRole } from "./RequireRole";
import { routeElements, type RouteElementProps } from "./routeElements";
import { routePatterns } from "./routeTitle";
import { ROUTE_DEFS } from "./routeTable";

// `Routes` wrapped so Sentry's router tracing integration (sentry.ts) can name transactions by
// the matched route pattern.
const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

/** Every page, guarded by its access level, plus each retired URL's redirect — all generated
 *  from the registry (`routeTable.tsx`). */
export function AppRoutes(props: RouteElementProps) {
	const elements = routeElements(props);
	return (
		<SentryRoutes>
			{ROUTE_DEFS.flatMap((route) => [
				...routePatterns(route).map((path) => (
					<Route
						key={path}
						path={path}
						element={<RequireRole access={route.access}>{elements[route.id]}</RequireRole>}
					/>
				)),
				...(route.redirectsFrom ?? []).map((redirect) => (
					<Route
						key={redirect.from}
						path={redirect.from}
						element={<LegacyRedirect to={redirect.to ?? route.path} search={redirect.search} />}
					/>
				)),
			])}
			{/* Catch-all: unmatched paths previously rendered a blank content area
			    (looked like a crash). See customer-portal-fjb2. */}
			<Route path="*" element={<NotFound />} />
		</SentryRoutes>
	);
}
